// loading.js
import loadingImage from '@/assets/images/loading.png';
export default {
  install(app) {
    const loadingElement = document.createElement("div");
    loadingElement.innerHTML = `
        <div id="app-loading" class="app-loading" style="display: none;">
          <div class="w-[max-content] h-[max-content] absolute l-0 r-0 t-0 b-0 m-auto flex">
            <img src="${loadingImage}" alt="" class="loading-base-img">
          </div>
        </div>
      `;
    document.body.appendChild(loadingElement);

    app.config.globalProperties.$Loading = {
      show() {
        loadingElement.querySelector(".app-loading").style.display = "block";
      },
      hide() {
        loadingElement.querySelector(".app-loading").style.display = "none";
      }
    };

    // 消息提示
    app.config.globalProperties.$Toast = (message, duration = 2500) => {
      const divEle = document.createElement("div");
      divEle.classList.add("message-toast");
      divEle.textContent = message;
      // 获取当前所有存在的 toast
      const existingToasts = document.querySelectorAll(".message-toast");
      // 如果存在其他 toast，给它们添加向下移出动画
      existingToasts.forEach(toast => {
        toast.classList.add("move-down");
        setTimeout(() => {
          if (toast.parentNode === document.body) {
            document.body.removeChild(toast);
          }
        }, 500); // 动画持续时间与 CSS 保持一致
      });
      document.body.append(divEle);
      // 使用 requestAnimationFrame 确保过渡效果生效
      requestAnimationFrame(() => {
        divEle.classList.add("show");
      });
      // 自动隐藏当前 toast
      setTimeout(() => {
        divEle.classList.remove("show");
        setTimeout(() => {
          if (divEle.parentNode === document.body) {
            document.body.removeChild(divEle);
          }
        }, 500);
      }, duration);
    };
    // 错误请求结果提示
    app.config.globalProperties.$ErrorToast = (message, duration = 2500) => {
      // 创建提示容器
      const divEle = document.createElement("div");
      divEle.classList.add("error-toast");
      document.body.appendChild(divEle);

      // 设置初始内容
      divEle.innerHTML = `
            <div class="error-toast-content ">
                <i class="error-icon inline-block h-[max-content] w-[max-content] sysicon-alert-error shrink-0 text-color-tip-3"></i>
                <span class="error-message flex-1 overflow-hidden whitespace-break-spaces shrink-0" style="color: #fff;">${message}</span>
                <div class="error-time shrink-0 text-color-2 font-700" id="error-toast-timer">3s</div>
            </div>
        `;
      // 更新秒数
      const timerElem = divEle.querySelector("#error-toast-timer");
      let remainingTime = Math.ceil(duration / 1000);
      requestAnimationFrame(() => {
        divEle.classList.add("show");
      });
      // 更新计时器
      const intervalId = setInterval(() => {
        remainingTime -= 1;
        timerElem.textContent = `${remainingTime}s`;

        if (remainingTime <= 0) {
          clearInterval(intervalId);
        }
      }, 1000);
      // 设置 3 秒后改变内容
      setTimeout(() => {
        divEle.classList.remove("show");
        divEle.classList.add("hide");
        // 延迟一段时间后从 DOM 中移除元素
        setTimeout(() => {
          if (divEle.parentNode === document.body) {
            document.body.removeChild(divEle);
          }
        }, 500); // 500ms 用于动画完成的过渡
      }, duration); // 3000ms 后开始隐藏
    };
  }
};
